import React, { useState } from 'react';
import { createInquiry } from '../api';
import { useUserContext } from '../UserContext';
import { errorMessage, KIND_OPTIONS } from './inboxFormat';

// An inquiry that came in by phone, email or in person, typed in by staff so it's
// tracked like the website ones.
function NewInquiryForm({ onClose, onCreated }) {
  const { user } = useUserContext();
  const [form, setForm] = useState({
    kind: 'dealership', company_name: '', contact_name: '', contact_role: '', email: '', phone: '', address: '', notes: '',
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    const { notes, ...fields } = form;
    try {
      const inquiry = await createInquiry({
        ...fields,
        details: notes.trim() ? { notes } : {},
        assigned_to: user ? user.id : null,
      });
      onCreated(inquiry);
    } catch (err) {
      setError(errorMessage(err, 'Could not save the inquiry.'));
      setBusy(false);
    }
  };

  return (
    <div className="inbox-modal-overlay" onClick={onClose}>
      <form className="inbox-modal inbox-subform" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <h3>Phone inquiry</h3>
        <label><span>Type</span>
          <select value={form.kind} onChange={set('kind')}>
            {KIND_OPTIONS.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </select>
        </label>
        <label><span>Company</span><input value={form.company_name} onChange={set('company_name')} /></label>
        <label><span>Name *</span><input value={form.contact_name} onChange={set('contact_name')} required /></label>
        <label><span>Role</span><input value={form.contact_role} onChange={set('contact_role')} /></label>
        <label><span>Email</span><input type="email" value={form.email} onChange={set('email')} /></label>
        <label><span>Phone</span><input value={form.phone} onChange={set('phone')} /></label>
        <label><span>Address</span><textarea rows={2} value={form.address} onChange={set('address')} /></label>
        <label><span>What they need</span><textarea rows={3} value={form.notes} onChange={set('notes')} /></label>
        {error && <div className="inbox-error">{error}</div>}
        <div className="inbox-actions">
          <button type="submit" className="inbox-button inbox-button-primary" disabled={busy}>Save</button>
          <button type="button" className="inbox-button" onClick={onClose}>Cancel</button>
        </div>
      </form>
    </div>
  );
}

export default NewInquiryForm;
